<template>
  <div v-if="!isMobile()">
    <div
      class="section section-landpresale"
      id="landpresale-section"
      data-background-color="black"
      style="
        background-image: url('/img/img_main_land_data.png');
        background-size: cover;
        background-position: center center;
        height: 100vh;
      "
    >
      <div data-aos="fade-up" data-aos-offset="-100" class="img_deco_06"></div>
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-12">
            <div class="row">
              <div
                style="
                  margin: 80px auto;
                  width: 720px;
                  height: 600px;
                  background-image: url('/img/bg_dark.png');
                  background-size: 100% 100%;
                  background-position: center center;
                  padding-top: 70px;
                "
              >
              <h1 class="title" style="text-transform: uppercase;">
                {{ $t(`Land Data`) }}
              </h1>
                <h5 style="width: 60%; margin: 120px auto 0px;">{{ $t(`land data desc1`) }}</h5>
                <h5 style="width: 60%; margin: 30px auto;">{{ $t(`land data desc2`) }}</h5>
                <div style="margin-top: 60px; width: 100%; text-align: center">
                  <n-button
                    @click="goLand()"
                    class="btn btn-main3 btn-wide2 btn-upper btn-lg"
                  >
                    {{ $t("Go LandPortal") }}
                  </n-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div
      class="section-m section-landpresale"
      id="landpresale-section"
      data-background-color="black"
      style="
        background-image: url('/img/img_main_land_data.png');
        background-size: cover;
        background-position: center center;
        height: 600px;
      "
    >
      <div class="img_deco_06"></div>
      <div class="container" style="width: 85%; margin-top: 10vh; height: 80vh">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-12">
            <div class="row">
              <div
                style="
                  background-image: url('/img/bg_dark.png');
                  min-height: 200px;
                  background-size: 100% 100%;
                  background-repeat: no-repeat;
                "
              >
                <h1 class="title-m deco2" style="margin-top: 10px">
                  {{ $t(`Land Data`) }}
                </h1>
                <div
                  style="
                    width: 90%;
                    margin: auto;
                    font-size: 1em;
                    font-weight: 300;
                    font-stretch: normal;
                    font-style: normal;
                    text-align: left;

                    color: #ffffff !important;
                    padding-top: 40px;
                  "
                >
                  <div>{{ $t(`land data desc1`) }}</div>
                  <div>{{ $t(`land data desc2`) }}</div>
                </div>
                <div
                  style="
                    margin-top: 40px;
                    margin-bottom: 10px;
                    width: 100%;
                    text-align: center;
                  "
                >
                  <n-button
                    @click="goLand()"
                    class="btn btn-main3 btn-wide btn-upper btn-lg"
                  >
                    {{ $t("Go LandPortal") }}
                  </n-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from "@/components";
export default {
  name: "landdata",
  components: {
    [Button.name]: Button,
  },
  methods: {
    goLand: async function () {
      let url = "//land.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style></style>
